// extracted by mini-css-extract-plugin
export default {"AppPageTitle":"AppPageTitle_AppPageTitle__s0c1b","AppPageTitle__container":"AppPageTitle_AppPageTitle__container__Wf0nx"};